import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const MOODS = ["🔥", "⚡", "🌊", "🌫️", "💀"];

export default function Journal() {
  const [entries, setEntries] = useState([]);
  const [content, setContent] = useState("");
  const [mood, setMood] = useState("⚡");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/journal").then((r) => setEntries(r.data));
  useEffect(() => {
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setBusy(true);
    try {
      await api.post("/journal", { content: content.trim(), mood });
      setContent("");
      toast.success("Entry logged");
      load();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="journal-page">
      <div>
        <div className="label-tech">Hunter's Log</div>
        <h1 className="h-display text-3xl sm:text-4xl mt-1">
          Daily <span className="text-cyan-400">Journal</span>
        </h1>
      </div>

      <form onSubmit={submit} className="panel panel-corners p-6 space-y-3">
        <div>
          <label className="label-tech block mb-2">Mood Signal</label>
          <div className="flex gap-2">
            {MOODS.map((m) => (
              <button
                type="button"
                key={m}
                onClick={() => setMood(m)}
                className={`w-10 h-10 border text-lg ${
                  mood === m ? "border-cyan-400 bg-cyan-500/10" : "border-white/10 hover:border-white/30"
                }`}
              >
                {m}
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className="label-tech block mb-1.5">Log Entry</label>
          <textarea
            data-testid="journal-content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={4}
            placeholder="What did you conquer today? What tried to conquer you?"
            className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none px-3 py-2.5 text-white text-sm"
          />
        </div>
        <button data-testid="journal-submit" disabled={busy} className="btn-neon">
          {busy ? "Sealing..." : "Seal Entry"}
        </button>
      </form>

      <div className="space-y-3">
        {entries.map((e) => (
          <div key={e.id} className="panel p-4" data-testid={`journal-entry-${e.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="font-mono-tech text-xs text-cyan-400">{e.day}</div>
              <div className="text-lg">{e.mood}</div>
            </div>
            <p className="text-sm text-slate-200 whitespace-pre-wrap">{e.content}</p>
          </div>
        ))}
        {entries.length === 0 && (
          <p className="text-sm text-slate-500 text-center py-8">
            The pen is your first sword. Log your first entry above.
          </p>
        )}
      </div>
    </div>
  );
}
